import script from "./OceanpaymentWrapperPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OceanpaymentWrapperPage.vue?vue&type=script&setup=true&lang=js"

import "./OceanpaymentWrapperPage.vue?vue&type=style&index=0&id=9ac153f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ac153f8"]])

export default __exports__